import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { addStep, fetchAction } from '../../../ducks/actions'
import ChooseType from '../New/ChooseType/ChooseType'

export default function AddStep({ match, history }) {
  const { id: actionId } = match.params
  const [submitting, setSubmitting] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAction(actionId))
  }, [dispatch, actionId])

  const handleChoose = async step => {
    try {
      setSubmitting(true)
      await dispatch(addStep(actionId, step))

      history.push(`/actions/${actionId}/steps/${step.id}`)
    } catch (err) {
      console.error(err)
    }

    setSubmitting(false)
  }

  return (
    <ChooseType
      onChoose={handleChoose}
      submitting={submitting}
      title="Add a Step"
    />
  )
}
